<template>
  <div class="uk-width-1-1@l uk-width-1-1@m  uk-width-1-1@s section1" grid>
    <p class="uk-text-center Description">{{description}}</p>
  </div>
</template>

<script>
export default {
  name: 'PropertySectionOne',
  props: ['description']
}
</script>

<style scoped>
  .Description {
    font-size: 18px;
    margin-top: 30px;
    margin-bottom: 50px;
  }
</style>
